import React from "react"
import { Link } from "gatsby"
import PropTypes from "prop-types"
import Media from "react-media"
import { OutboundLink } from "gatsby-plugin-google-analytics"

import logo from "../images/header/logo.svg"

// chrome
import hamburger from "../images/header/hamburger.svg"
import close from "../images/header/close.svg"
import account from "../images/header/account.svg"
import cart from "../images/header/cart.svg"

class Dropdown extends React.Component {
  constructor(props) {
    super(props)
    const { name } = props
    this.state = {
      open: false,
    }
    this.name = name
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
  }

  open() {
    this.setState({
      open: true,
    })
  }

  close() {
    this.setState({
      open: false,
    })
  }

  render() {
    const { open } = this.state
    const { children } = this.props
    return (
      <div
        className="menu__item t6"
        role="menu"
        tabIndex="-1"
        onFocus={this.open}
        onMouseOver={this.open}
        onBlur={this.close}
        onMouseOut={this.close}
      >
        <div className="menu__dropdown">
          {this.name}
          <div className="menu__dropdown__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="4"
              viewBox="0 0 8 4"
            >
              <path
                fill="none"
                fillRule="evenodd"
                stroke="#494E52"
                strokeWidth="2"
                d="M8 0L4 4 0 0"
              />
            </svg>
          </div>
        </div>
        <div className={`items t7 ${open ? "active" : ""}`}>{children}</div>
      </div>
    )
  }
}

Dropdown.propTypes = {
  children: PropTypes.node.isRequired,
  name: PropTypes.string,
}

Dropdown.defaultProps = {}


class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuOpen: false,
    }
    this.toggleMenu = this.toggleMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
  }

  closeMenu(shouldClose) {
    const { toggleScrollable } = this.props
    const { menuOpen } = this.state
    if (shouldClose && menuOpen) {
      this.setState({ menuOpen: false })
      toggleScrollable(true)
    }
  }

  toggleMenu(event) {
    if (event.keyCode && event.keyCode !== 13) {
      return
    }
    const { toggleScrollable } = this.props
    const { menuOpen } = this.state
    this.setState({
      menuOpen: !menuOpen,
    })
    toggleScrollable(menuOpen)
  }

  render() {
    const { menuOpen } = this.state
    const { separator } = this.props

    return (
      <header
        className={`main-header ${menuOpen ? "as-menu" : ""} ${
          separator ? "separator" : ""
        }`}
      >
        <Media query="(min-width: 680px)" onChange={this.closeMenu} />
        <div className="mobile">
          <div
            role="button"
            tabIndex="-1"
            onClick={this.toggleMenu}
            onKeyDown={this.toggleMenu}
          >
            {menuOpen ? (
              <img src={close} alt="Close menu" />
            ) : (
              <img src={hamburger} alt="Open menu" />
            )}
          </div>
        </div>
        <Link to="/" tabIndex="-1" className="logo">
          <img src={logo} alt="BrightSuite" />
        </Link>
        <nav className="menu">
          <Dropdown name="Shop">
            <Link
              to="/popular/"
              className="items__item t7"
              activeClassName="active"
            >
              <div className="items__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 23 20">
                  <path fill="none" fill-rule="evenodd" stroke="#0072CE" stroke-width="2" d="M11.507 18.438l-8.914-8.54a5.168 5.168 0 0 1 7.149-7.463l1.765 1.693 1.765-1.693a5.168 5.168 0 0 1 7.148 7.463l-8.913 8.54z"/>
                </svg>
              </div>
              <div>By&nbsp;Popular&nbsp;Package</div>
            </Link>
            <Link
              to="/experiences/"
              className="items__item t7"
              activeClassName="active"
            >
              <div className="items__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 22 23">
                  <path fill="none" fill-rule="evenodd" stroke="#0072CE" stroke-width="2" d="M13.122 21.138v-7.183a2.676 2.676 0 0 0-5.352 0v7.183H1V7.598L10.634 2l9.633 5.597v13.541h-7.145z"/>
                </svg>
              </div>
              <div>By&nbsp;Experience&nbsp;Package</div>
            </Link>
            <Link
              to="/build-your-own/"
              className="items__item t7"
              activeClassName="active"
            >
              <div className="items__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 21 25">
                  <g fill="none" fill-rule="evenodd" stroke="#0072CE" stroke-width="2">
                    <path d="M1 23.349h18.759V8.157H1z"/>
                    <path d="M6.581 12.284V4.798a3.798 3.798 0 0 1 7.597 0v7.486"/>
                  </g>
                </svg>
              </div>
              <div>Build&nbsp;Your&nbsp;Own&nbsp;Package</div>
            </Link>
          </Dropdown>
          <Link
            to="/monitoring/"
            className="menu__item t6"
            activeClassName="active"
          >
            Monitoring&nbsp;Plans
          </Link>
          <Link
            to="/overview/"
            className="menu__item t6"
            activeClassName="active"
          >
            Overview
          </Link>
          <Dropdown name="Support">
            <Link
              to="/about/"
              className="items__item t7"
              activeClassName="active"
            >
              <div>About Us</div>
            </Link>
            <Link
              to="/faq/#Questions"
              className="items__item t7"
              activeClassName="active"
            >
              <div>FAQ</div>
            </Link>
            <Link
              to="/faq/#Contact"
              className="items__item t7 header-contact"
              activeClassName="active"
            >
              <div>Contact</div>
            </Link>
            <Link
              to="/works-with/"
              className="items__item t7"
              activeClassName="active"
            >
              <div>Works&nbsp;With</div>
            </Link>
          </Dropdown>
        </nav>
        {/* <div className="user">
          <img class="user__phone" src="/all/phone-icon.png"/>
          <span>833.374.8637</span>
          <div class="verticalLine">

          </div>
          <OutboundLink
            href="https://shop.brightsuite.com/customer/account/login/referer/aHR0cHM6Ly9zaG9wLmJyaWdodHN1aXRlLmNvbS9jdXN0b21lci9hY2NvdW50L2luZGV4Lw%2C%2C/"
            className="user__account"
          >
            <span>Sign In</span>
          </OutboundLink>
          <OutboundLink
            href="https://shop.brightsuite.com/packagelist/?category=all"
            className="user__cart"
          >
            <img src={cart} alt="Your cart" />
          </OutboundLink>
        </div> */}
        <div className="user">
          <OutboundLink
            href="https://shop.brightsuite.com/customer/account/login/"
            className="user__account"
          >
            <img src={account} alt="Your account" />
          </OutboundLink>
          <OutboundLink
            href="https://shop.brightsuite.com/checkout/cart/"
            className="user__cart"
          >
            <img src={cart} alt="Your cart" />
          </OutboundLink>
        </div>
      </header>
    )
  }
}

Header.propTypes = {
  toggleScrollable: PropTypes.func.isRequired,
  separator: PropTypes.bool.isRequired,
}

export default Header
